var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.groupCards
        ? "card-container mt-2 flex-start g-2"
        : "card-container mt-2"
    },
    [
      _c("el-card", [
        _c(
          "div",
          { staticClass: "flex-aligned" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exibirInfoCards,
                    expression: "exibirInfoCards"
                  }
                ],
                staticClass: "mr-5"
              },
              [
                _c("h2", [_vm._v(_vm._s(_vm.titleCard))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-info-container mt-2" },
                  _vm._l(_vm.infosCard, function(info, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c("Label", {
                          attrs: {
                            label:
                              info.label +
                              ": " +
                              _vm.formataDescricao(info.label, info.descricao)
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            ),
            _vm._v(" "),
            _vm._t("info-card")
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-249bc856", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-249bc856","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Cards/CardBase/CardBase.vue
// module id = null
// module chunks = 